import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { EAssemblyOrderStatus } from 'v2/modules/assembly-order/interfaces';

@Component({
  selector: 'lum-sales-order-line-items-assembly-order-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './sales-order-line-items-assembly-order-dialog.component.html',
  styleUrls: ['./sales-order-line-items-assembly-order-dialog.component.scss'],
})
export class SalesOrderLineItemsAssemblyOrderDialogComponent {
  orderStatus :EAssemblyOrderStatus = EAssemblyOrderStatus.DRAFT;
  eAssemblyOrderStatus = EAssemblyOrderStatus;
  constructor(
    public dialogRef :MatDialogRef<SalesOrderLineItemsAssemblyOrderDialogComponent>,
  ) {}

  onSubmit() :void {
    this.dialogRef.close(this.orderStatus);
  }
}
